import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api, { apiError } from "../lib/api";
import { Landmark, Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sid });
        setSession(data);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (err) {
        setError(apiError(err));
        setTimeout(() => navigate("/login", { replace: true }), 2200);
      }
    })();
  }, [navigate, setSession]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-forest text-white">
      <div className="h-12 w-12 rounded-xl bg-white/10 flex items-center justify-center mb-5">
        <Landmark className="h-6 w-6" />
      </div>
      {error ? (
        <p className="text-sm text-red-200">{error} — redirecting…</p>
      ) : (
        <p className="flex items-center gap-2 text-sm text-forest-muted"><Loader2 className="h-4 w-4 animate-spin" /> Signing you in…</p>
      )}
    </div>
  );
}
